import React, { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { getReUploadDocAction } from '../../../redux/actions/signupAction';
import Tooltip from '@mui/material/Tooltip';
import { Refresh } from '@mui/icons-material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Box, Skeleton, Typography } from '@mui/material';

export const EachUploadTile = ({
  docArr,
  eachUploadInstruction,
  index,
  onTileClick,
}) => {
  const dispatch = useDispatch();
  const defaultTileThumbnail = '../../../../assets/img/camera.svg';
  const defaultThumbnailClass = 'camera-icon';
  const [thumbnailURL, setThumbnailURL] = useState(defaultTileThumbnail);
  const [thumbnailClass, setThumbnailClass] = useState(defaultThumbnailClass);
  // const [progress, setProgress] = useState(0);
  const [currentDocument, setCurrentDocument] = useState({});
  const [docRreUpload, setDocRreUpload] = useState(false);
  const loadingIdType = useSelector(
    (state) => state?.signup?.loadingIdentificationIdType
  );

  const handleReupload = (event) => {
    event.stopPropagation();
    currentDocument['reUpload'] = true;
    dispatch(getReUploadDocAction({ data: currentDocument, dispatch }));
  };

  const handleCurrentTileClick = () => {
    if (!loadingIdType) {
      onTileClick({ ...eachUploadInstruction, reUpload: docRreUpload });
    }
  };

  useEffect(() => {
    const tileItem = docArr.find(
      (eachDoc) =>
        eachDoc.imageUploadNumber ===
          eachUploadInstruction?.imageUploadNumber &&
        eachDoc?.docTypeCode === eachUploadInstruction?.docTypeCode
    );
    setCurrentDocument((pre) => {
      pre = { ...tileItem };
      return { ...pre };
    });
    if (tileItem?.fileURL) {
      if (tileItem?.imageFile?.type.includes('pdf')) {
        setThumbnailURL('../../../../../assets/img/pdf-1.png');
      } else {
        setThumbnailURL(tileItem.fileURL);
      }
      setThumbnailClass('img-thumbnail');
    } else {
      setThumbnailURL(defaultTileThumbnail);
      setThumbnailClass(defaultThumbnailClass);
    }
  }, [eachUploadInstruction, docArr]);

  useEffect(() => {
    if (currentDocument?.uploadStatus === 'failed') {
      setDocRreUpload(true);
    }
    if (
      currentDocument?.uploadStatus === 'inProgress' ||
      currentDocument?.uploadStatus === 'pending'
    ) {
      setDocRreUpload(false);
    }
  }, [currentDocument?.uploadStatus]);

  useEffect(() => {
    if (loadingIdType) {
      setThumbnailURL(defaultTileThumbnail);
      setThumbnailClass(defaultThumbnailClass);
    }
  }, [loadingIdType]);

  return (
    <div
      className="col-sm-12 col-md-6"
      onClick={handleCurrentTileClick}
      key={`${eachUploadInstruction.docTypeCode}_${index}`}
    >
      <div
        className={
          currentDocument?.uploadStatus === 'failed'
            ? 'upload-img mb-3 upload-error'
            : 'upload-img mb-3'
        }
      >
        <div className="img-thumbnail-m">
          {loadingIdType ? (
            <Skeleton
              className="img-placeholder"
              animation="wave"
              variant="circular"
              width={40}
              height={40}
            />
          ) : (
            <img src={thumbnailURL} className={thumbnailClass} />
          )}
        </div>

        <p className="title w-100">
          {loadingIdType ? (
            <>
              <Skeleton
                animation="wave"
                height={10}
                width="80%"
                style={{ marginBottom: 6 }}
              />
              <Skeleton animation="wave" height={10} width="40%" />
            </>
          ) : (
            eachUploadInstruction.instructionText
          )}
        </p>
        {(currentDocument.uploadStatus === undefined ||
          currentDocument?.uploadStatus === null) &&
          !docRreUpload && (
            <div className="icon">
              <div className="arroy-icon-upload">
                <img src="../../../../assets/img/angleToRight.svg" />
              </div>
            </div>
          )}
        {(currentDocument?.uploadStatus === 'pending' ||
          currentDocument.uploadProgress === 0) && (
          <div className="icon">
            <CircularProgress
              color="inherit"
              className="custom-icon custom-completed"
            />
          </div>
        )}
        {currentDocument?.uploadStatus === 'inProgress' &&
          currentDocument?.uploadProgress &&
          currentDocument.uploadProgress > 0 && (
            <div className="icon">
              <Box className="progress-percentage-parent-box">
                <CircularProgress
                  variant="determinate"
                  value={currentDocument ? currentDocument.uploadProgress : 0}
                  className="custom-icon custom-completed custom-icon-2"
                />
                <Box className="progress-percentage-box">
                  <Typography
                    className="progress-percentage"
                    variant="caption"
                    component="div"
                    color="text.secondary"
                  >{`${Math.round(
                    currentDocument ? currentDocument.uploadProgress : 0
                  )}%`}</Typography>
                </Box>
              </Box>
            </div>
          )}
        {currentDocument?.uploadStatus === 'uploaded' && (
          <div className="icon">
            <Tooltip title="Uploaded successfully">
              <CheckCircleOutlineOutlinedIcon className="custom-icon custom-completed custom-icon-3" />
            </Tooltip>
          </div>
        )}
        {docRreUpload && (
          <>
            {currentDocument?.uploadStatus === 'failed' && (
              <div className="icon icon-and-badge-retry">
                <Tooltip title="Retry">
                  <Refresh
                    className="custom-icon custom-completed custom-icon-3"
                    onClick={(e) => handleReupload(e)}
                  />
                </Tooltip>
              </div>
            )}
            {currentDocument?.uploadStatus === null && (
              <div className="icon">
                <div className="upload-ind-wrap">
                  <Tooltip title="Upload">
                    <FileUploadIcon
                      className="custom-icon-file-upload"
                      onClick={(e) => handleReupload(e)}
                    />
                  </Tooltip>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      {currentDocument?.uploadStatus === 'failed' && (
        <div className="upload-error-msg">
          {currentDocument?.errorText
            ? currentDocument?.errorText
            : 'Failed upload'}
        </div>
      )}
    </div>
  );
};
